import { FiCreditCard } from "react-icons/fi";
import { FaFolderOpen } from "react-icons/fa";
import { IoAppsSharp } from "react-icons/io5";
import { useNavigate, useLocation } from "react-router-dom";

const NavButtons = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="nav-buttons">
      <button
        className={`nav-btn ${location.pathname === "/home-my-cards" ? "active" : ""}`}
        onClick={() => navigate("/home-my-cards")}
      >
        <FiCreditCard className="btn-icon" /> My Cards
        {location.pathname === "/home-my-cards" && <div className="underline"></div>}
      </button>

      <button
        className={`nav-btn ${location.pathname === "/home-my-holder" ? "active" : ""}`}
        onClick={() => navigate("/home-my-holder")}
      >
        <FaFolderOpen className="btn-icon" /> My Holder
        {location.pathname === "/home-my-holder" && <div className="underline"></div>}
      </button>

      <button
        className={`nav-btn ${location.pathname === "/home-web-holder" ? "active" : ""}`}
        onClick={() => navigate("/home-web-holder")}
      >
        <IoAppsSharp className="btn-icon" /> Web Holder
        {location.pathname === "/home-web-holder" && <div className="underline"></div>}
      </button>
    </div>
  );
};

export default NavButtons;
